<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[{ name: 'BannerCenter', to: { path: '/banner-center' } }]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>BannerCenter</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="toSlidebannerCreate">
        <v-icon class="mr-2 white--text">add</v-icon>
        <span>新增橫幅廣告</span>
      </button>
    </div>
    <!-- block -->
    <div class="block mb-5">
      <SlidebannerCenterTable></SlidebannerCenterTable>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import SlidebannerCenterTable from '@/views/B-12__SlideBanner/c/SlidebannerCenterTable.vue';

export default {
  components: {
    Breadscrumbs,
    SlidebannerCenterTable,
  },
  created() {
    this.clear();
    this.getSlidebannerList();
  },
  methods: {
    ...mapActions('slidebanner', {
      getSlidebannerList: 'find',
      clear: 'clear',
    }),
    toSlidebannerCreate() {
      this.$router.push('/banner-center/create');
    },
  },
};
</script>

<style></style>
